import "./styles/App.css";
import twitterLogo from "./assets/twitter-logo.svg";
import { ethers } from "ethers";
import React, { useEffect, useState } from "react";
import myEpicNft from "./utils/MyEpicNFT.json";
import DisplayConnectionInfo from "./components/DisplayConnectionInfo";
import AlertBox from "./components/AlertBox";
import { handleAlert } from "./utils/alertUtil";
import DisplayNFTCount from "./components/DisplayNFTCount";

const TWITTER_HANDLE = "PranshuJain04";
const TWITTER_LINK = `https://twitter.com/${TWITTER_HANDLE}`;
const OPENSEA_LINK = "";
const TOTAL_MINT_COUNT = 50;

// I moved the contract address to the top for easy access.
const CONTRACT_ADDRESS = "0x70e9318349E7a2590Ce272728A7adB26a6a250a8";

const App = () => {
  const [currentAccount, setCurrentAccount] = useState("");
  const [alertInfo, setAlertInfo] = useState({
    amessage: "Hiii how are you?",
    acolor: "#000000",
    show: false,
    full: false,
  });
  const [remainingNFTs, setRemainingNFTs] = useState(0);
  const checkIfWalletIsConnected = async () => {
    const { ethereum } = window;

    if (!ethereum) {
      console.log("Make sure you have metamask!");
      return;
    } else {
      console.log("We have the ethereum object", ethereum);
    }

    const accounts = await ethereum.request({ method: "eth_accounts" });

    if (accounts.length !== 0) {
      const account = accounts[0];
      console.log("Found an authorized account:", account);
      setCurrentAccount(account);

      // Setup listener! This is for the case where a user comes to our site
      // and ALREADY had their wallet connected + authorized.
      setupEventListener();
    } else {
      console.log("No authorized account found");
    }
  };

  const connectWallet = async () => {
    try {
      const { ethereum } = window;

      if (!ethereum) {
        handleAlert("Get MetaMask", "red", setAlertInfo);
        return;
      }

      const accounts = await ethereum.request({
        method: "eth_requestAccounts",
      });

      console.log("Connected", accounts[0]);
      setCurrentAccount(accounts[0]);

      // Setup listener! This is for the case where a user comes to our site
      // and connected their wallet for the first time.
      setupEventListener();
    } catch (error) {
      console.log(error);
    }
  };

  // Setup our listener.
  const setupEventListener = async () => {
    // Most of this looks the same as our function askContractToMintNft
    try {
      const { ethereum } = window;

      if (ethereum) {
        // Same stuff again
        const provider = new ethers.providers.Web3Provider(ethereum);
        const signer = provider.getSigner();
        const connectedContract = new ethers.Contract(
          CONTRACT_ADDRESS,
          myEpicNft.abi,
          signer
        );
        let completed = (
          await connectedContract.getTotalNFTsMintedSoFar()
        ).toNumber();

        let total = (await connectedContract.getMaxNFTsLimit()).toNumber();
        console.log("Remain: ", total - completed);
        let result = total - completed + 1;
        setRemainingNFTs(result);
        // THIS IS THE MAGIC SAUCE.
        // This will essentially "capture" our event when our contract throws it.
        // If you're familiar with webhooks, it's very similar to that!
        connectedContract.on("NewEpicNFTMinted", (from, tokenId) => {
          console.log(from, tokenId.toNumber());
          let message = `Hey there! We've minted your NFT and sent it to your wallet ✨ It may be blank right now. It can take a max of 10 min to show up on OpenSea. Here's the link: `;
          let link = `https://testnets.opensea.io/assets/${CONTRACT_ADDRESS}/${tokenId.toNumber()}`;
          setAlertInfo({
            amessage: message,
            acolor: "#000000",
            full: true,
            show: true,
            link: link,
          });
          // alert(
          //   `Hey there! We've minted your NFT and sent it to your wallet. It may be blank right now. It can take a max of 10 min to show up on OpenSea. Here's the link: https://testnets.opensea.io/assets/${CONTRACT_ADDRESS}/${tokenId.toNumber()}`
          // );
        });

        console.log("Setup event listener!");
      } else {
        console.log("Ethereum object doesn't exist!");
      }
    } catch (error) {
      console.log("Some catch occured");
      console.log(error);
    }
  };

  const askContractToMintNft = async () => {
    try {
      const { ethereum } = window;

      if (ethereum) {
        const provider = new ethers.providers.Web3Provider(ethereum);
        const signer = provider.getSigner();
        const connectedContract = new ethers.Contract(
          CONTRACT_ADDRESS,
          myEpicNft.abi,
          signer
        );

        console.log("Going to pop wallet now to pay gas...");
        let nftTxn = await connectedContract.makeAnEpicNFT();

        console.log("Mining...please wait.");
        setAlertInfo({
          amessage: "Mining in progress... ⚒",
          acolor: "rgba(242, 91, 31,0.95)",
          show: true,
          full: true,
        });
        await nftTxn.wait();
        // handleAlert(
        //   `Mined, see transaction: https://rinkeby.etherscan.io/tx/${nftTxn.hash}`,
        //   "#09b812",
        //   setAlertInfo,
        //   6000
        // );
        console.log(
          `Mined, see transaction: https://rinkeby.etherscan.io/tx/${nftTxn.hash}`
        );
      } else {
        handleAlert("Make sure you have metamask!", "#0f5200", setAlertInfo);
        console.log("Ethereum object doesn't exist!");
      }
    } catch (error) {
      handleAlert("Some error occured!", "red", setAlertInfo);
      console.log(error);
    }
  };

  useEffect(() => {
    checkIfWalletIsConnected();
  }, []);

  const renderNotConnectedContainer = () => (
    <button
      onClick={connectWallet}
      className="cta-button connect-wallet-button"
    >
      Connect to Wallet
    </button>
  );

  const renderMintUI = () => (
    <button
      onClick={askContractToMintNft}
      className="cta-button connect-wallet-button"
    >
      Mint NFT
    </button>
  );

  return (
    <div className="App">
      <div className="container">
        <DisplayConnectionInfo currentAccount={currentAccount} />
        <DisplayNFTCount
          remainingNFTs={remainingNFTs}
          currentAccount={currentAccount}
        />

        {alertInfo.show && (
          <AlertBox setAlertInfo={setAlertInfo} alertInfo={alertInfo} />
        )}
        <div className="header-container">
          <p className="header gradient-text">Hello, I'm Pranshu</p>
          <p className="sub-text">
            Click on the Mint NFT Button after connecting to wallet to get your
            UNIQUE and BEAUTIFUL NFT today.
          </p>
          {currentAccount === ""
            ? renderNotConnectedContainer()
            : renderMintUI()}
          <div className="collection">
            <a href="https://testnets.opensea.io/collection/squarenft-dkzhvrdrs2">
              View our NFTs Collection
            </a>
          </div>
        </div>

        <div className="footer-container">
          <img alt="Twitter Logo" className="twitter-logo" src={twitterLogo} />
          <a
            className="footer-text"
            href={TWITTER_LINK}
            target="_blank"
            rel="noreferrer"
          >{`@${TWITTER_HANDLE}`}</a>
        </div>
      </div>
    </div>
  );
};

export default App;
